var _circle, _path, _path2, _path3, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoItem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 33,
    fill: "#E5EAEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 41.7577H17C15.8954 41.7577 15 40.8622 15 39.7577V22.7196C15 21.615 15.8954 20.7196 17 20.7196H29.5629H48C49.1046 20.7196 50 21.615 50 22.7196V39.7577C50 40.8622 49.1046 41.7577 48 41.7577Z",
    fill: "#9DA7AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5709 19.7838L18.5473 19.8016C17.8409 20.3332 17.4711 21.2006 17.5766 22.0782L19.9149 41.5289L49.7505 38.393L47.4093 18.9172C47.3052 18.0513 46.7609 17.3006 45.9701 16.9325L45.9203 16.9093C45.1069 16.5306 44.1509 16.6311 43.434 17.1706C42.7171 17.7101 41.7611 17.8106 40.9477 17.4319C40.1342 17.0532 39.1783 17.1537 38.4614 17.6932C37.7444 18.2328 36.7885 18.3332 35.9751 17.9546C35.1616 17.5759 34.2057 17.6763 33.4888 18.2159C32.7718 18.7554 31.8159 18.8559 31.0025 18.4772C30.189 18.0985 29.2331 18.199 28.5162 18.7385C27.7992 19.2781 26.8433 19.3785 26.0299 18.9998C25.2164 18.6212 24.2605 18.7216 23.5435 19.2612C22.8266 19.8007 21.8707 19.9012 21.0572 19.5225C20.2438 19.1438 19.2879 19.2443 18.5709 19.7838Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 49.2487H48C49.1046 49.2487 50 48.3533 50 47.2487V27.2107H26.1747C25.8153 27.2107 25.4835 27.0178 25.3057 26.7055L23.6054 23.7196H17C15.8954 23.7196 15 24.615 15 25.7196V47.2487C15 48.3533 15.8954 49.2487 17 49.2487Z",
    fill: "#C1CAD0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.75,
    y: 32,
    width: 2.5,
    height: 7,
    fill: "white",
    fillOpacity: 0.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.75,
    y: 40.5,
    width: 2.5,
    height: 2.5,
    fill: "white",
    fillOpacity: 0.7
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoItem);
export default __webpack_public_path__ + "static/media/noItem.3ab5abd4d25bbc2ea87b6cb2cc99f252.svg";
export { ForwardRef as ReactComponent };